import React from 'react';
import PropTypes from 'prop-types';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { TextField } from '@bingads-webui-react/fabric-with-signal';

const getStyles = () => ({
  container: {
    display: 'flex',
  },
  bid: {
    width: '150px',
    marginRight: '12px',
  },
  currency: {
    marginTop: '5px',
  },
  messageBar: {
    marginTop: '5px',
  },
});

export const DefaultBid = ({
  // eslint-disable-next-line
  i18n, currencyCode, id, getRangeWaring, disabled, value,...rest
}) => {
  const classes = useDefaultStyles(getStyles);
  return (
    <div id={id} className={classes.container}>
      <div className={classes.bid}>
        <TextField
          id="input-ad-group-bid"
          ariaLabel="default-bid"
          i18n={i18n}
          disabled={disabled}
          value={disabled? i18n.getString(_TL_('Auto')) : value}
          {...rest}
        />
      </div>
      <span className={classes.currency}>{currencyCode}</span>
    </div>);
};

DefaultBid.propTypes = {
  i18n: PropTypes.shape({}).isRequired,
  currencyCode: PropTypes.string.isRequired,
  id: PropTypes.string,
  classes: PropTypes.shape({
    container: PropTypes.string.isRequired,
    bid: PropTypes.string.isRequired,
    currency: PropTypes.string.isRequired,
  }).isRequired,
  validationProps: PropTypes.shape({}).isRequired,
  getRangeWaring: PropTypes.func,
  disabled: PropTypes.bool,
};

DefaultBid.defaultProps = {
  id: '',
  getRangeWaring: () => null,
  disabled: false,
};
